<div class="chat-header">
  <span class="pointer" (click)="restartConversation()">
    @if (agentCard?.title) {
    {{ agentCard.title }}
    } @else { Reiniciar conversación }
  </span>

  @for (conversation of alternativeConversation; track conversation._id) {
  <span class="pointer" (click)="restartConversation(conversation)"> {{ conversation.title }} </span>
  }

  <div class="header-controls">
    @if (isAdmin()){
    <div class="admin-controls">
      <i style="color: rgb(255, 149, 0)" class="pi pi-key"></i>

      <i (click)="complete()">⚡️ </i>

      <p-button variant="text" [raised]="true" icon="pi pi-id-card" (click)="showInfo()"></p-button>

      <span class="pointer" (click)="openFeedback()"> 📝 </span>
      <span class="pointer" (click)="openCostDetails()"> 💰 </span>
      @if (conversationCostService.totalTokens() > 0) {
      <div class="token-counter">
        <span>
          📥 {{ conversationCostService.totalInputTokens() }}
          <span style="font-size: small; color: rgb(74, 74, 74)">${{ conversationCostService.totalInputCost() | number : '1.4-4' }}</span>
        </span>
        <span>
          📤 {{ conversationCostService.totalOutputTokens() }}
          <span style="font-size: small; color: rgb(74, 74, 74)">${{ conversationCostService.totalOutputCost() | number : '1.4-4' }}</span>
        </span>
        <span>
          🧮 {{ conversationCostService.totalTokens() }}
          <span style="font-size: small; color: rgb(74, 74, 74)">${{ conversationCostService.totalCost() | number : '1.4-4' }}</span>
        </span>
        <span> <i class="pi pi-cloud-upload"></i> {{ conversationCostService.totalApiCalls() }} </span>
      </div>
      }
    </div>

    }

    <div>
      <span class="pointer" (click)="settingsClick()"> ⚙️ </span>
    </div>
  </div>
</div>
